export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS'
export const UPDATE_PROFILE_FAIL = 'UPDATE_PROFILE_FAIL'
export const SHOW_PROFILE_SUCCESS = 'SHOW_PROFILE_SUCCESS'
export const SHOW_PROFILE_FAIL = 'SHOW_PROFILE_FAIL'